import ModeloShow from './ModeloShow'
export {ModeloShow}
export default ModeloShow
